// Hearth theme — editorial cream paper, terracotta accent.
export const theme = {
  name: 'Hearth',
  bg:        '#F4ECDB',
  surface:   '#FBF6EA',
  surface2:  '#F7EFDC',
  ink:       '#221912',
  inkSoft:   '#5B4C3F',
  muted:     '#A99480',
  line:      'rgba(34,25,18,0.10)',
  lineStrong:'rgba(34,25,18,0.18)',
  accent:    '#B85339',
  accentInk: '#7A2E18',
  olive:     '#6E7A3D',
  butter:    '#E8B25A',
  cooked:    '#6E7A3D',
  skipped:   '#A99480',
  planned:   '#B85339',
  serif:     "'Newsreader', 'Cormorant Garamond', Georgia, serif",
  sans:      "'DM Sans', ui-sans-serif, system-ui, sans-serif",
  mono:      "'JetBrains Mono', ui-monospace, Menlo, monospace",
  headWeight: 400,
  radius: 4,
  radiusLg: 6,
  cardBorder: '1px solid rgba(34,25,18,0.10)',
  cardShadow: 'none',
} as const

export type Theme = typeof theme
